import { Slide } from '@mui/material';
import { BaseSlideProps } from './BaseSlide.types';

/**
 * A customizable slide component that wraps the MUI Slide component.
 *
 * @param children - {@link SlideProps.children children} description.
 * @param direction - {@link BaseSlideProps.direction direction} description.
 * @param props - {@link BaseSlideProps props} description.
 */
export const BaseSlide = ({
    direction,
    children,
    ...props
}: BaseSlideProps) => {
    return (
        <Slide
            {...props}
            direction={direction}
        >
            {children}
        </Slide>
    );
};